import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { LiquidityGaugeV5Factory } from "../codegen/LiquidityGaugeV5Factory";
import { VaultLiquidityMiningMap } from "../constants/constants";
import { useETHWeb3Context } from "./web3Context";
export var getLiquidityGaugeV5 = function (library, vaultOption, useSigner) {
    if (useSigner === void 0) { useSigner = true; }
    var provider = useSigner ? library.getSigner() : library;
    if (!VaultLiquidityMiningMap.lg5[vaultOption]) {
        return null;
    }
    return LiquidityGaugeV5Factory.connect(VaultLiquidityMiningMap.lg5[vaultOption], provider);
};
var useLiquidityGaugeV5 = function (vaultOption) {
    var _a = useWeb3React(), active = _a.active, library = _a.library;
    var provider = useETHWeb3Context().provider;
    var _b = useState(null), contract = _b[0], setContract = _b[1];
    useEffect(function () {
        if (provider) {
            var vault = getLiquidityGaugeV5(library || provider, vaultOption, active);
            setContract(vault);
        }
    }, [provider, active, library, vaultOption]);
    return contract;
};
export default useLiquidityGaugeV5;
//# sourceMappingURL=useLiquidityGaugeV5.js.map